import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import Utils from '../../utils';
import GameUtils from '../../utils/game';
import Screens from '..';
import QueryParamsProxy from '../../utils/queryParamProxy';
import { isEqual } from '../../utils/object';
import routeParamConstants from '../../utils/routeParamConstants';
import ShopInterface from '../../api/ShopInterface';
import AppBackgroundType from '../../utils/AppBackgroundType';
import TimestampManager from '../../utils/TimestampManager';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
var PAGE_SIZE = 8;

var VIPGames = /*#__PURE__*/function (_Component) {
  _inherits(VIPGames, _Component);

  var _super = _createSuper(VIPGames);

  function VIPGames() {
    var _this;

    _classCallCheck(this, VIPGames);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      timeRemaining: 0,
      canEnterRoom: true,
      games: [],
      featuredGames: [],
      panelList: [],
      numColumn: 0,
      pagedGames: []
    };
    _this.timer = undefined;
    _this.deactivateTimer = null;
    _this.isVipGames = false;
    _this._getLivePanelList = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var gameRooms, panelList, pagedGames;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              gameRooms = _this.props.gameRooms;
              _context.next = 3;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 200);
              });

            case 3:
              /** @type {LobbyItemsInfo} */
              panelList = [];

              if (gameRooms && gameRooms.gameList && gameRooms.gameList[0]) {
                panelList = gameRooms.gameList[0].games;
              }

              panelList = panelList.filter(function (game) {
                return !game.IS_HIDDEN;
              });
              pagedGames = new Array(Math.ceil(panelList.length / PAGE_SIZE)).fill().map(function (currentPage, index) {
                return panelList.slice(index * PAGE_SIZE, (index + 1) * PAGE_SIZE);
              });

              _this.setState({
                panelList: gameRooms && gameRooms.gameList[0] && gameRooms.gameList[0].games,
                numColumn: 1,
                pagedGames: pagedGames
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this._itemClickHandler = function (id) {
      _this.props.setGameId(id);

      _this.isVipGames = true;
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Game, _defineProperty({}, routeParamConstants.PARAM_GAME_ID, id));
    };

    _this._playClickHandler = function () {
      _this.props.setFirstTimeVisitVipRoom(false);
    };

    _this.initGameRoomData = function (gameRooms, favouriteGames) {
      var canEnterRoom = true;
      var games = [];
      var featuredGames = [];

      if (!Utils.isEmpty(gameRooms)) {
        _this._playClickHandler();

        for (var i = 0; i < gameRooms.length; i++) {
          var room = gameRooms[i];

          if (room.can_enter_room) {
            if (!Utils.isEmpty(room.news)) {
              for (var n = 0; n < room.news.length; n++) {
                if (!room.news[n].IS_HIDDEN) {
                  featuredGames.push(room.news[n]);
                }
              }
            }

            if (!Utils.isEmpty(room.games)) {
              for (var g = 0; g < room.games.length; g++) {
                if (!room.games[g].IS_HIDDEN) {
                  games.push(_objectSpread(_objectSpread({}, room.games[g]), {}, {
                    isVip: true,
                    isFavourite: GameUtils.isFavouriteGame(favouriteGames, room.games[g].GAME_ID)
                  }));
                }
              }
            }
          }
        }
      }

      if (Utils.isEmpty(games) && Utils.isEmpty(featuredGames)) {
        canEnterRoom = false;
      }

      _this.setState({
        canEnterRoom: canEnterRoom,
        games: games,
        featuredGames: featuredGames
      });
    };

    _this.getRemainingTime = function () {
      var remainingTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var activeConsumables = _this.props.activeConsumables;

      if (activeConsumables) {
        var vip_room_access = activeConsumables.vip_room_access;

        if (vip_room_access) {
          var secondsUntilExpires = remainingTime || vip_room_access.seconds_until_expiry;
          return Date.now() + secondsUntilExpires * 1000;
        }
      }

      return 0;
    };

    _this.setTimeRemaining = function (timeRemaining) {
      _this.setState({
        timeRemaining: timeRemaining
      });

      if (!_this.timer) {
        _this.timer = TimestampManager.register(_this.props.activeConsumables.vip_room_access.seconds_until_expiry * 1000, function () {
          _this.setState({
            timeRemaining: 0,
            canEnterRoom: false
          });
        });
      }
    };

    return _this;
  }

  _createClass(VIPGames, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          setAppBackground = _this$props.setAppBackground,
          gameRooms = _this$props.gameRooms,
          favouriteGames = _this$props.favouriteGames,
          showVipAccessModal = _this$props.showVipAccessModal,
          isVipRoomUnlocked = _this$props.isVipRoomUnlocked;
      setAppBackground(AppBackgroundType.VIP_GAMES);
      ShopInterface.refreshActiveConsumables();
      var timeRemaining = this.getRemainingTime();

      if (timeRemaining > 0) {
        this.setTimeRemaining(timeRemaining);

        this._playClickHandler();
      } else if (showVipAccessModal && !isVipRoomUnlocked) {
        this.deactivateTimer = window.setTimeout(function () {
          QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, Screens.VipAccessFlow));
        }, 800);
      }

      this._getLivePanelList();

      this.initGameRoomData(gameRooms.gameList, favouriteGames.gameList);
      Logger.sendEvent(EVENT_TYPES.GAME_ROOM_LOADED, {
        name: 'VIPRoom'
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.gameRooms.gameList && !isEqual(nextProps.gameRooms.gameList, this.props.gameRooms.gameList) || this.props.favouriteGames.gameList && !isEqual(nextProps.favouriteGames.gameList, this.props.favouriteGames.gameList)) {
        var gameRooms = nextProps.gameRooms.gameList;
        var favouriteGames = nextProps.favouriteGames.gameList;
        this.initGameRoomData(gameRooms, favouriteGames);
      }

      if (this.props.activeConsumables.vip_room_access && nextProps.activeConsumables.vip_room_access) {
        if (this.props.activeConsumables.vip_room_access.seconds_until_expiry !== nextProps.activeConsumables.vip_room_access.seconds_until_expiry) {
          this.setTimeRemaining(this.getRemainingTime(nextProps.activeConsumables.vip_room_access.seconds_until_expiry));
        }
      }

      if (nextProps.gameRooms !== this.props.gameRooms) {
        this._getLivePanelList();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.isVipGames === false) {
        this.props.setAppBackground(AppBackgroundType.NORMAL);
      }

      TimestampManager.unregister(this.timer);
      window.clearTimeout(this.deactivateTimer);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.render(_objectSpread(_objectSpread(_objectSpread({}, this.state), this.props), {}, {
        firstTimeAccess: this.props.ftue.vipRoom,
        canEnterRoom: this.state.canEnterRoom,
        timeRemaining: this.state.timeRemaining,
        games: this.state.games,
        featuredGames: this.state.featuredGames,
        itemClick: this._itemClickHandler,
        playClick: this._playClickHandler,
        pageNumber: 0 // Initial page for the VIP room should always be the first

      }));
    }
  }]);

  return VIPGames;
}(Component);

export { VIPGames as default };